import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0688d975"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "low-frequency-live-emp-page" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "低频访问客户信息", -1))

import { computed, onMounted, ref } from 'vue'
import { ElMessage } from 'element-plus'
import { Download, QuestionFilled } from '@element-plus/icons-vue'
import { CrudSearch, CrudTable } from '@/components/crud-v2'
import { usePagedCrud } from '@/hooks/crud/usePagedCrud'
import { usePermission } from '@/hooks/usePermission'
import { useStore } from '@/store'
import type { CrudSelectOption } from '@/types/crud-config'
import {
  createLowFrequencyLiveEmpSearchItems,
  lowFrequencyLiveEmpTableColumns
} from './low-frequency-live-emp.config'
import {
  exportLowFrequencyLiveEmp,
  fetchLowFrequencyLiveEmpEmployees,
  fetchLowFrequencyLiveEmpPage
} from './low-frequency-live-emp.service'
import type { LowFrequencyLiveEmpFilters } from './low-frequency-live-emp.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'LowFrequencyLiveEmp',
  setup(__props) {

const store = useStore()
const canList = usePermission('lowFrequencyLiveEmp', 'list')
const canDownload = usePermission('lowFrequencyLiveEmp', 'download')

const filterRules = [
  '筛选规则：',
  '1、根据直播链接后缀匹配',
  '2、客户归属 —— 必须是本人名下的客户',
  '3、默认查询30天内观看直播天数小于7天的用户'
]

function createFilters(): LowFrequencyLiveEmpFilters {
  return {
    empName: store.state.login.userInfo.realName,
    dayRange: 30,
    maxWatchDays: 7
  }
}

const {
  filters,
  pageNo,
  pageSize,
  records,
  total,
  lastSuccessfulQuery,
  error,
  loading,
  load,
  search,
  reset,
  changePage,
  changePageSize,
  refresh
} = usePagedCrud({ createFilters, fetchPage: fetchLowFrequencyLiveEmpPage })

const employeeOptions = ref<CrudSelectOption[]>([])
const optionsLoading = ref(false)
const exporting = ref(false)

const searchItems = computed(() =>
  createLowFrequencyLiveEmpSearchItems(
    employeeOptions.value,
    optionsLoading.value
  )
)
const errorMessage = computed(() =>
  error.value instanceof Error ? error.value.message : ''
)

function runQuery(action: () => Promise<boolean>) {
  return canList ? action() : Promise.resolve(false)
}

async function loadEmployeeOptions() {
  optionsLoading.value = true
  try {
    const employees = await fetchLowFrequencyLiveEmpEmployees()
    employeeOptions.value = employees.map((item) => ({
      label: item.realName,
      value: item.realName
    }))
  } catch (cause) {
    ElMessage.error(
      cause instanceof Error ? cause.message : '员工选项加载失败，请稍后重试'
    )
  } finally {
    optionsLoading.value = false
  }
}

function saveBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

async function download() {
  if (!lastSuccessfulQuery.value) return

  exporting.value = true
  try {
    saveBlob(
      await exportLowFrequencyLiveEmp(lastSuccessfulQuery.value),
      '低频访问客户信息.xlsx'
    )
  } catch (cause) {
    ElMessage.error(cause instanceof Error ? cause.message : '导出失败')
  } finally {
    exporting.value = false
  }
}

onMounted(() => {
  loadEmployeeOptions()
  runQuery(load)
})

return (_ctx: any,_cache: any) => {
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(CrudSearch), {
      model: _unref(filters),
      items: searchItems.value,
      loading: _unref(loading),
      onSearch: _cache[0] || (_cache[0] = ($event: any) => (runQuery(_unref(search)))),
      onReset: _cache[1] || (_cache[1] = ($event: any) => (runQuery(_unref(reset))))
    }, null, 8, ["model", "items", "loading"]),
    _createVNode(_unref(CrudTable), {
      rows: _unref(records),
      "page-no": _unref(pageNo),
      "page-size": _unref(pageSize),
      total: _unref(total),
      loading: _unref(loading),
      "error-message": errorMessage.value,
      columns: _unref(lowFrequencyLiveEmpTableColumns),
      onPageChange: _cache[2] || (_cache[2] = ($event: any) => (runQuery(() => _unref(changePage)($event)))),
      onPageSizeChange: _cache[3] || (_cache[3] = ($event: any) => (runQuery(() => _unref(changePageSize)($event)))),
      onRetry: _cache[4] || (_cache[4] = ($event: any) => (runQuery(_unref(refresh))))
    }, {
      title: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_el_popover, {
          placement: "top",
          width: 380,
          trigger: "hover",
          "popper-class": "is-dark low-frequency-live-emp-filter-popover"
        }, {
          reference: _withCtx(() => [
            _createVNode(_unref(QuestionFilled), {
              class: "low-frequency-live-emp-page__title-icon",
              "aria-label": "筛选规则"
            })
          ]),
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(filterRules, (rule) => {
              return _createElementVNode("div", { key: rule }, _toDisplayString(rule), 1)
            }), 64))
          ]),
          _: 1
        })
      ]),
      actions: _withCtx(() => [
        (_unref(canDownload))
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              type: "primary",
              loading: exporting.value,
              disabled: !_unref(lastSuccessfulQuery),
              onClick: download
            }, {
              default: _withCtx(() => [
                (!exporting.value)
                  ? (_openBlock(), _createBlock(_unref(Download), {
                      key: 0,
                      class: "low-frequency-live-emp-page__button-icon",
                      "aria-hidden": "true"
                    }))
                  : _createCommentVNode("", true),
                _createTextVNode(" 下载 ")
              ]),
              _: 1
            }, 8, ["loading", "disabled"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["rows", "page-no", "page-size", "total", "loading", "error-message", "columns"])
  ]))
}
}

})